import React, { FC } from 'react';
import classNames from 'classnames';

import Link from '../../Controls/Link';
import Icon from '@sv-support-sdk/ui-components/src/components/Media/Icon';

import { IBreadcrumb } from './index';

import css from './style.module.scss';

interface IProps {
  item: IBreadcrumb;
}

const BreadcrumbsItem: FC<IProps> = ({ item: { link, text, isLast} }) => {
  return (
    <div className={css.breadcrumbs__item} >
      <Link
        to={link}
        textDecoration="none"
        className={classNames(css.breadcrumbs__link, { [css.last]: isLast })}
      >
        {text}
      </Link>
      {!isLast && (
        <div className={css.breadcrumbs__icon}>
          <Icon id="20--chevron-right" />
        </div>
      )}
    </div>
  );
};

export default BreadcrumbsItem;
